import { apiUrl } from '../variables'
import Auth from '../modules/Authentication'

const auth = new Auth()

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}

export const API_URL = `${apiUrl}/`

export async function handleErrors(response) {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    throw await response.json()
  }
}

export async function handleResponse(response) {
  return await response.json()
}

export function handelRequests({
  method,
  url,
  data,
  isApi = true,
  isJsonRequest = true,
  hasResponse = true,
  useAuth = true,
}) {
  if (useAuth) {
    headers.authorization = `Bearer ${auth.getAccessToken()}`
  }

  const options = {
    method,
    body: data,
  }
  if (isJsonRequest) {
    options.headers = headers
  }

  return fetch(`${isApi ? API_URL : ''}${url}`, options)
    .then(handleErrors)
    .then(hasResponse ? handleResponse : (error) => error)
}
